<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useAuth0 } from '@auth0/auth0-vue'
import AppShell from '@/components/layout/AppShell.vue'
import TourOverlay from '@/components/common/TourOverlay.vue'
import { useTourStore } from '@/stores/tour'

// Gate rendering until Auth0 SDK initializes to avoid flicker on redirect.
const { isLoading } = useAuth0()

// Per-page guided tour ("Vodič kroz ovu stranicu") — mounted once, globally, so the
// overlay survives whatever its steps click (tabs, hash changes) on the page below.
const tour = useTourStore()
</script>

<template>
    <AppShell v-if="!isLoading">
        <RouterView />
    </AppShell>
    <TourOverlay v-if="tour.active" :steps="tour.steps" @close="tour.stop()" />
    <div
        v-else
        class="flex h-full items-center justify-center text-sm"
        style="color: var(--color-ink-muted)">
        {{ $t('appHeader.loading') }}
    </div>
</template>
